/**
 * Normaliza mensagem de erro vindas da API ou um erro de execução com try/catch
 * 
 * @param {Error} erro Instancia do Error gerado num try/catch
 * @returns {string} Mensagem de erro normalizada
 */
function normalizaMensagemApi(erro = null) {
    const responseData = erro?.response?.data || {};
    // Diferentes mensagens de erros vindas da api ou ainda no momento da execução ou dentro do then
    return responseData.mensagemErro
        || responseData.mensagem
        || responseData.message
        || responseData.error
        || responseData.erro
        || erro?.message
        || 'Algo deu errado, tente novamente mais tarde.';
}

module.exports = normalizaMensagemApi;
